export const CMF_LINK = 'https://informedeudas.cmfchile.cl/informedeudacb/aplicacion?indice=110.0';
